class TkOffersDrawer extends HTMLElement {
  static TOOLTIP_DELAY = 400;
  static TOOLTIP_DURATION = 4000;

  connectedCallback() {
    // init-once: l'editor può riconnettere il custom element spostando la sezione
    if (this.dataset.tkInitialized) return;
    this.dataset.tkInitialized = 'true';

    this.removeAttribute('hidden');

    this.overlay = this.querySelector('.tk-offers-drawer__overlay');
    this.inner = this.querySelector('.tk-offers-drawer__inner');
    this.trigger = document.getElementById('OffersDrawer-trigger');
    this.tooltip = document.querySelector('.tk-offers-trigger__tooltip');

    this.bindEvents();
    this.scheduleTooltip();
  }

  bindEvents() {
    // handler statico: addEventListener deduplica ref identiche, niente doppio bind sul trigger persistente
    if (this.trigger) this.trigger.addEventListener('click', TkOffersDrawer.openFromTrigger);
    if (this.overlay) this.overlay.addEventListener('click', this.close.bind(this));
    this.querySelectorAll('[data-offers-drawer-close]').forEach((btn) =>
      btn.addEventListener('click', this.close.bind(this))
    );
    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });

    // Theme editor: apri il drawer quando la sezione o un blocco offerta è selezionato,
    // chiudilo alla deselezione. Handler statici → dedup su re-init dell'editor.
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', TkOffersDrawer.editorSelect);
      document.addEventListener('shopify:block:select', TkOffersDrawer.editorSelect);
      document.addEventListener('shopify:section:deselect', TkOffersDrawer.editorDeselect);
      document.addEventListener('shopify:block:deselect', TkOffersDrawer.editorDeselect);
    }
  }

  static openFromTrigger(event) {
    event.preventDefault();
    const drawer = document.getElementById('OffersDrawer');
    if (drawer) drawer.open();
  }

  static isEditorEventForDrawer(event, drawer) {
    return event.target.contains(drawer) || drawer.contains(event.target);
  }

  static editorSelect(event) {
    const drawer = document.getElementById('OffersDrawer');
    if (!drawer || !TkOffersDrawer.isEditorEventForDrawer(event, drawer)) return;
    clearTimeout(drawer.pendingEditorClose);
    drawer.open();
  }

  static editorDeselect(event) {
    const drawer = document.getElementById('OffersDrawer');
    if (!drawer || !TkOffersDrawer.isEditorEventForDrawer(event, drawer)) return;
    // debounce: passando tra due blocchi, deselect+select nello stesso tick non deve far lampeggiare
    drawer.pendingEditorClose = setTimeout(() => drawer.close(), 50);
  }

  open() {
    setTimeout(() => this.classList.add('active'));
    this.trigger?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');
    this.addEventListener('transitionend', () => trapFocus(this.inner, this.inner), { once: true });
  }

  close() {
    this.classList.remove('active');
    this.trigger?.setAttribute('aria-expanded', 'false');
    removeTrapFocus(this.trigger);
    // non sbloccare lo scroll se un altro drawer (es. cart-drawer, classe .drawer) è ancora aperto
    if (!document.querySelector('.drawer.active')) {
      document.body.classList.remove('overflow-hidden');
    }
  }

  scheduleTooltip() {
    if (!this.tooltip) return;
    setTimeout(() => {
      this.tooltip.classList.add('is-visible');
      setTimeout(() => this.tooltip.classList.remove('is-visible'), TkOffersDrawer.TOOLTIP_DURATION);
    }, TkOffersDrawer.TOOLTIP_DELAY);
  }
}

customElements.define('tk-offers-drawer', TkOffersDrawer);
